'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateFns = require('date-fns');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('react-day-picker/lib/style.css');

var _reactDayPicker = require('react-day-picker');

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

var _Container = require('./components/Container.WeekPicker');

var _Container2 = _interopRequireDefault(_Container);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var WeekPicker = function (_Component) {
  _inherits(WeekPicker, _Component);

  function WeekPicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WeekPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WeekPicker.__proto__ || Object.getPrototypeOf(WeekPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hover: undefined
    }, _this.tabindex = function () {
      (0, _jquery2.default)('[tabindex]', (0, _jquery2.default)('.WeekPicker')).each(function () {
        (0, _jquery2.default)(this).attr('tabindex', '-1');
      });
    }, _this.hover = function (date) {
      var _this$range = _this.range(date),
          start = _this$range.start,
          end = _this$range.end;

      _this.setState({
        hover: {
          from: start,
          to: end
        }
      });
    }, _this.blur = function () {
      _this.setState({
        hover: undefined
      });
    }, _this.range = function (date) {
      return {
        start: (0, _dateFns.startOfWeek)(date, {
          weekStartsOn: 1
        }),
        end: (0, _dateFns.endOfWeek)(date, {
          weekStartsOn: 1
        })
      };
    }, _this.onChange = function (date) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$selected = _ref2.selected,
          selected = _ref2$selected === undefined ? false : _ref2$selected,
          _ref2$disabled = _ref2.disabled,
          disabled = _ref2$disabled === undefined ? false : _ref2$disabled;

      if (selected || disabled) return;
      var stringDate = (0, _dateFns.format)((0, _dateFns.startOfWeek)(date, {
        weekStartsOn: 1
      }), 'YYYY-MM-DD');

      _this.props.onChange(stringDate);
    }, _this.getDate = function () {
      var value = _this.props.value;
      if (!value) return [];

      var _this$range2 = _this.range(value),
          start = _this$range2.start,
          end = _this$range2.end;

      return (0, _dateFns.eachDay)(start, end);
    }, _this.initialMonth = function () {
      var _this$props = _this.props,
          month = _this$props.month,
          value = _this$props.value;
      if (!!value) return (0, _dateFns.parse)(value);
      return month || new Date();
    }, _this.disabled = function () {
      var disabledDates = _this.props.disabledDates;

      var formDate = function formDate(from, to) {
        return {
          after: (0, _dateFns.subSeconds)(from, 1),
          before: (0, _dateFns.addSeconds)(to, 1)
        };
      };

      return [].concat(_toConsumableArray(disabledDates)).map(function (disabled) {
        if ((0, _dateFns.isDate)(disabled)) {
          var _this$range3 = _this.range(disabled),
              start = _this$range3.start,
              end = _this$range3.end;

          return [formDate(start, end)];
        }

        if (!!disabled.before && !!disabled.after) {
          var _start = _this.range(disabled.before);

          var _end = _this.range(disabled.after);

          return [formDate(_start.start, _start.end), formDate(_end.start, _end.end)];
        }

        if (!!disabled.before) return [{
          before: (0, _dateFns.addSeconds)((0, _dateFns.endOfWeek)(disabled.before, {
            weekStartsOn: 1
          }), 1)
        }];
        if (!!disabled.after) return [{
          after: (0, _dateFns.subSeconds)((0, _dateFns.startOfWeek)(disabled.after, {
            weekStartsOn: 1
          }), 1)
        }];
        return disabled;
      }).flat();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WeekPicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.tabindex();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.value !== this.props.value) {
        this.tabindex();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var hover = this.state.hover;
      var inline = this.props.inline;
      var modifiers = {
        hoverRange: hover,
        hoverRangeStart: hover && hover.from,
        hoverRangeEnd: hover && hover.to
      };
      return _react2.default.createElement(_Container2.default, {
        className: 'WeekPicker',
        inline: inline,
        tabIndex: '-1'
      }, _react2.default.createElement(_reactDayPicker2.default, {
        'aria-readonly': 'true',
        selectedDays: this.getDate(),
        onDayClick: this.onChange,
        disabledDays: this.disabled(),
        month: this.initialMonth(),
        modifiers: modifiers,
        onDayMouseEnter: this.hover,
        onDayMouseLeave: this.blur,
        firstDayOfWeek: 1,
        showOutsideDays: true
      }));
    }
  }]);

  return WeekPicker;
}(_react.Component);

WeekPicker.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  disabledDates: _propTypes2.default.array,
  month: _propTypes2.default.instanceOf(Date),
  inline: _propTypes2.default.bool,
  skipDisabledCheck: _propTypes2.default.bool
};
WeekPicker.defaultProps = {
  disabledDates: [],
  month: null,
  inline: false,
  skipDisabledCheck: false
};
exports.default = WeekPicker;